module.exports = __webpack_public_path__ + "img/BGD.62d36db1.svg";